<template>
	<div>
		<v-row >
			<v-col cols="4" class="text-center pb-0 pt-12">
				<span class="subtitle-1"></span>
			</v-col>

			<template v-if="hf == 'hours'">
				<v-col cols="4" class="text-center pb-0 pt-12">
					<span class="subtitle-1">Отработанные часы</span>
				</v-col>
				<v-col cols="4" class="text-center pb-0 pt-12">
					<span class="subtitle-1">Среднесписочная численность</span>
				</v-col>
			</template>

			<template v-else>
				<v-col cols="4" class="text-center pb-0 pt-12">
					<span class="subtitle-1">Приемы</span>
				</v-col>
				<v-col cols="4" class="text-center pb-0 pt-12">
					<span class="subtitle-1">Увольнения</span>
				</v-col>
			</template>

		</v-row>

		<v-row >
			<v-col class="pt-0" cols="4" >
				<span class="title">{{ groupName }}</span>
			</v-col>
			<v-col cols="2" class="text-center">
				<span class="subtitle-1">{{ lastMonth }}</span>
			</v-col>
			<v-col cols="2" class="text-center">
				<span class="subtitle-1">{{ month }}</span>
			</v-col>
			<v-col cols="2" class="text-center">
				<span class="subtitle-1">{{ lastMonth }}</span>
			</v-col>
			<v-col cols="2" class="text-center">
				<span class="subtitle-1">{{ month }}</span>
			</v-col>
		</v-row>

		<v-row >
			<v-col class="py-4" cols="12" >
				<span class="title">{{ eo == 'emp' ? 'Сотрудники' : 'Аутсорсинг' }}</span>
			</v-col>
		</v-row>

		<template v-for="(line, lineKey) in lines">
			<v-row v-if="lineKey != 'name'" :key="lineKey">
				<v-col class="py-2" cols="4" >
					<v-tooltip bottom max-width="500" v-if="line.tooltip">
						<template v-slot:activator="{ on }">
							<span class="subtitle-1" v-on="on">{{ line.name }}</span>
						</template>
						<span>{{ line.tooltip }}</span>
					</v-tooltip>
					<span class="subtitle-1" v-else>{{ line.name }}</span>
				</v-col>

				<template v-if="hf == 'hours'">
					<v-col class="py-0" cols="2" >
						<a-number-field v-model="line.hours.value[0]"
									 class="my-0 py-0"
									 readonly
									 digits=0>
						</a-number-field>
					</v-col>
					<v-col class="py-0" cols="2" >
						<a-number-field v-model="line.hours.value[1]"
									 class="my-0 py-0"
									 @input.native="$emit('data-changed', emitter)"
									 @change.native="$emit('data-changed', emitter)"
									 :readonly="readonly"
									 digits=0>
						</a-number-field>
					</v-col>
				</template>

				<template v-if="hf == 'hours' && eo == 'emp'">
					<v-col class="py-0" cols="2" >
						<a-number-field v-model="line.headcount.value[0]"
									 class="my-0 py-0"
									 readonly
									 digits=2>
						</a-number-field>
					</v-col>
					<v-col class="py-0" cols="2" >
						<a-number-field v-model="line.headcount.value[1]"
									 class="my-0 py-0"
									 @input.native="$emit('data-changed', emitter)"
									 :readonly="readonly"
									 digits=2>
						</a-number-field>
					</v-col>
				</template>

				<template v-if="hf == 'hires' && eo == 'emp'">
					<v-col class="py-0" cols="2" >
						<a-number-field v-model="line.hires.value[0]"
									 class="my-0 py-0"
									 readonly
									 digits=0>
						</a-number-field>
					</v-col>
					<v-col class="py-0" cols="2" >
						<a-number-field v-model="line.hires.value[1]"
									 class="my-0 py-0"
									 @input.native="$emit('data-changed', emitter)"
									 :readonly="readonly"
									 digits=0>
						</a-number-field>
					</v-col>
					<v-col class="py-0" cols="2" >
						<a-number-field v-model="line.fires.value[0]"
									 class="my-0 py-0"
									 readonly
									 digits=0>
						</a-number-field>
					</v-col>
					<v-col class="py-0" cols="2" >
						<a-number-field v-model="line.fires.value[1]"
									 class="my-0 py-0"
									 @input.native="$emit('data-changed', emitter)"
									 :readonly="readonly"
									 digits=0>
						</a-number-field>
					</v-col>
				</template>

			</v-row>
		</template>
		<v-row>
			<v-col class="py-0" cols="4" >
				<div class="mt-4">
					<span class="subtitle-1">Итого {{ eo == 'emp' ? 'сотрудники' : 'аутсорсинг' }}</span>
				</div>
			</v-col>

			<template v-if="hf == 'hours'">
				<v-col class="py-0" cols="2" >
					<a-number-field :value="totalHours0"
								 readonly
								 prepend-icon="functions"
								 digits=0>
					</a-number-field>
				</v-col>
				<v-col class="py-0" cols="2" >
					<a-number-field :value="totalHours1"
								 readonly
								 prepend-icon="functions"
								 digits=0>
					</a-number-field>
				</v-col>
			</template>

			<template v-if="hf == 'hours' && eo == 'emp'">
				<v-col class="py-0" cols="2" >
					<a-number-field :value="totalHeadcount0"
								 readonly
								 prepend-icon="functions"
								 digits=2>
					</a-number-field>
				</v-col>
				<v-col class="py-0" cols="2" >
					<a-number-field :value="totalHeadcount1"
								 readonly
								 prepend-icon="functions"
								 digits=2>
					</a-number-field>
				</v-col>
			</template>

			<template v-if="hf == 'hires' && eo == 'emp'">
				<v-col class="py-0" cols="2" >
					<a-number-field :value="totalHires0"
								 readonly
								 prepend-icon="functions"
								 digits=0>
					</a-number-field>
				</v-col>
				<v-col class="py-0" cols="2" >
					<a-number-field :value="totalHires1"
								 readonly
								 prepend-icon="functions"
								 digits=0>
					</a-number-field>
				</v-col>
				<v-col class="py-0" cols="2" >
					<a-number-field :value="totalFires0"
								 readonly
								 prepend-icon="functions"
								 digits=0>
					</a-number-field>
				</v-col>
				<v-col class="py-0" cols="2" >
					<a-number-field :value="totalFires1"
								 readonly
								 prepend-icon="functions"
								 digits=0>
					</a-number-field>
				</v-col>
			</template>
		</v-row>
	</div>
</template>

<script>
	import aNumberField from '../../base/ANumberField.vue'
	import {toNum, toStr} from '../../../js/common.js'

	export default {
		components: {
			aNumberField
		},
		props: {
			tab: [Number, String],
			groupName: String,
			month: String,
			lastMonth: String,
			hf: String,
			eo: String,
			lines: Object,
			// emitTrigger: Boolean,
			readonly: Boolean
		},
		data: () => ({
		}),
		// watch: {
		// 	emitTrigger: function (val) {
		// 		if (val) {
		// 			this.$emit('data-changed', this.emitter)
		// 		}
		// 	}
		// },
		computed: {
			totals() {
				if (this.hf == 'hours') {
					return {
						hours: [
							this.totalHours0,
							this.totalHours1
						],
						headcount: [
							this.totalHeadcount0,
							this.totalHeadcount1
						]
					}
				}
				else {
					return {
						hires: [
							this.totalHires0,
							this.totalHires1
						],
						fires: [
							this.totalFires0,
							this.totalFires1
						]
					}
				}

			},
			emitter() {
				return {
					totals: this.totals,
					hf: this.hf,
					eo: this.eo,
					tab: this.tab
				}
			},
			totalHours0() {
				// console.log('totalHours0')
				let sum = 0

				for (let line in this.lines) {
					if (this.lines[line].hours) {
						sum += toNum(this.lines[line].hours.value[0])
					}
				}
				sum = toStr(sum, 0)

				return sum
			},
			totalHours1() {
				// console.log('totalHours1')
				let sum = 0

				for (let line in this.lines) {
					if (this.lines[line].hours) {
						sum += toNum(this.lines[line].hours.value[1])
					}
				}
				sum = toStr(sum, 0)

				return sum
			},
			totalHeadcount0() {
				// console.log('totalHeadcount0')
				let sum = 0

				for (let line in this.lines) {
					if (this.lines[line].headcount) {
						sum += toNum(this.lines[line].headcount.value[0])
					}
				}
				sum = toStr(sum, 2)

				return sum
			},
			totalHeadcount1() {
				// console.log('totalHeadcount1')
				let sum = 0

				for (let line in this.lines) {
					if (this.lines[line].headcount) {
						sum += toNum(this.lines[line].headcount.value[1])
					}
				}
				sum = toStr(sum, 2)

				return sum
			},
			totalHires0() {
				// console.log('totalHires0')
				let sum = 0

				for (let line in this.lines) {
					if (this.lines[line].hires) {
						sum += toNum(this.lines[line].hires.value[0])
					}
				}
				sum = toStr(sum, 0)

				return sum
			},
			totalHires1() {
				// console.log('totalHires1')
				let sum = 0

				for (let line in this.lines) {
					if (this.lines[line].hires) {
						sum += toNum(this.lines[line].hires.value[1])
					}
				}
				sum = toStr(sum, 0)

				return sum
			},
			totalFires0() {
				// console.log('totalFires0')
				let sum = 0

				for (let line in this.lines) {
					if (this.lines[line].fires) {
						sum += toNum(this.lines[line].fires.value[0])
					}
				}
				sum = toStr(sum, 0)

				return sum
			},
			totalFires1() {
				// console.log('totalFires1')
				let sum = 0

				for (let line in this.lines) {
					if (this.lines[line].fires) {
						sum += toNum(this.lines[line].fires.value[1])
					}
				}
				sum = toStr(sum, 0)

				return sum
			},
		},
		created() {

		},
		methods: {

		}
	}
</script>
